<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style:none;margin:10px 0;">
            <li>
                <div>
                    <h3>B.Tech in Computer Science & Engineering </h3>
                    <hr>
                    <dl>
                        <dt>JSS Academy of Technical Education, Noida (2016-2020)</dt>
                        <dd><i>Affiliated to Abdul Kalam Technical University,Lukhnow</i></dd>
                        <dd>CGPA:8.6</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>XII (Senior Secondary),in PCM with CS</h3>
                    <hr>
                    <dl>
                        <dt>Boys' High School and College, Allahabad (2015-2016)</dt>
                        <dd><i>Affiliated to ISC Board</i></dd>
                        <dd>Percentage:97%</dd>
                        <dd>School topper and 2nd rank holder in city</dd>
                    </dl>
                </div>
            </li>
            <li>
                <div>
                    <h3>X (Secondary), in Science</h3>
                    <hr>
                    <dl>
                        <dt>Boys' High School and College, Allahabad (2013-2014)</dt>
                        <dd><i>Affiliated to ISC Board</i></dd>
                        <dd>Percentage:93%</dd>
                        <dd>School rank 10th</dd>
                    </dl>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Education"
};
</script>



// WEBPACK FOOTER //
// src/components/educationComponent.vue